import { render, staticRenderFns } from "./Mensaje.vue?vue&type=template&id=c20d593a&scoped=true&"
import script from "./Mensaje.vue?vue&type=script&lang=js&"
export * from "./Mensaje.vue?vue&type=script&lang=js&"
import style0 from "./Mensaje.vue?vue&type=style&index=0&id=c20d593a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20d593a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
